import { DataObjectRounded } from "@mui/icons-material";
import { objectEach } from "highcharts";
import { FemsData } from "../../fems/datas/FemsData";
import { FxmsData } from "../../fxms/datas/FxData";

export class VupData extends FemsData {

  static initData(callback) {

    super.initData(function (obj) {

      FxmsData.selectBoxDatas.initData("inloFacility", "vup/code/facility/false", "facNo", "facName", "get",{}, true);
      FxmsData.selectBoxDatas.initData("utFac", "vup/code/facility/true", "facNo", "facName", "get",{}, true);

      FxmsData.selectBoxDatas.initData("inloPipe", "vup/code/pipe", "pipeId", "pipeName", "get",{}, true);
    
      FxmsData.selectBoxDatas.initData("sinkProdInlo", "vup/code/sinkProdInlo", "inloNo", "inloName", "get",{}, true);  // source & sink 회사
      FxmsData.selectBoxDatas.initData("sinkProdPlantInlo", "vup/code/sinkProdPlantInlo", "inloNo", "inloName", "get",{}, true);  // source & sink 공장

      FxmsData.selectBoxDatas.initData("sourceCompanyInlo", "vup/code/sourceInlo", "inloNo", "inloName", "get",{}, true);               // source 회사
      FxmsData.selectBoxDatas.initData("sourcePlantInlo", "vup/code/sourceInlo/Source", "inloNo", "inloName", "get",{}, true);     // source 공장

      FxmsData.selectBoxDatas.initData("sinkCompanyInlo", "vup/code/sinkInlo", "inloNo", "inloName", "get",{}, true);                   // sink 회사
      FxmsData.selectBoxDatas.initData("sinkPlantInlo", "vup/code/sinkInlo/Sink", "inloNo", "inloName", "get",{}, true);           // sink 공장

      // VUP 전용 SELECT 박스 데이터
      FxmsData.selectBoxDatas.initData(
        "inlo",
        "vup/code/inlo",
        "inloNo",
        "inloName",
        "get",
        {},
        true,
        function (datas) {
          if (obj) {
            obj.inlo = datas;
          } else {
            obj = { inlo: datas };
          }

          callback(obj);

          console.log("*** VupData initData ***", datas);

        }
      );
    } );
  }

}